import {FormControl, MenuItem, Select, SelectChangeEvent, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useFormContext} from 'react-hook-form';
import {RequestScheduleSelectPeriod} from '../RequestScheduleSelectPeriod';
import {RequestScheduleSchema} from '../RequestScheduleLayout/validation/schemas/RequestScheduleSchema';
import {
	AvailabilityEnum,
	REQUEST_SCHEDULE_DEFAULT_VALUES,
} from '../RequestScheduleLayout/constants';
import {RequestScheduleSelectPeriodTypeEnum} from '../RequestScheduleSelectPeriod/constants';

const {availability, availabilityOptions, selectPeriod1, selectPeriod2, morning, afternoon, night} =
	translations['pt-br'].privateFlow.bookingFlow.requestSchedule;

export const RequestScheduleAvailabilitySelect = () => {
	const {
		setValue,
		watch,
		formState: {errors},
	} = useFormContext<RequestScheduleSchema>();
	const availabilityWatched = watch('availability');

	const isRestriction = availabilityWatched === AvailabilityEnum.RESTRICTION;

	const handleChangeAvailability = (e: SelectChangeEvent) => {
		setValue('availability', e.target.value as AvailabilityEnum);
		setValue('morning', REQUEST_SCHEDULE_DEFAULT_VALUES.morning);
		setValue('afternoon', REQUEST_SCHEDULE_DEFAULT_VALUES.afternoon);
		setValue('night', REQUEST_SCHEDULE_DEFAULT_VALUES.night);
	};

	return (
		<Stack gap={2}>
			<Typography variant="subtitle2" color="text.secondary">
				{availability}
			</Typography>
			<FormControl fullWidth>
				<Select value={availabilityWatched} onChange={handleChangeAvailability}>
					<MenuItem value={AvailabilityEnum.ANY_DAY}>
						{availabilityOptions.anyDay}
					</MenuItem>
					<MenuItem value={AvailabilityEnum.RESTRICTION}>
						{availabilityOptions.restriction}
					</MenuItem>
				</Select>
			</FormControl>
			{isRestriction ? (
				<Stack>
					<Typography variant="subtitle2" color="text.secondary">
						{selectPeriod1} <b>{selectPeriod2}</b>
					</Typography>
					{errors?.availability ? (
						<Typography variant="caption" fontWeight={400} color={'error'}>
							{errors?.availability?.message}
						</Typography>
					) : null}
					<Stack>
						<RequestScheduleSelectPeriod
							periodLabel={morning}
							type={RequestScheduleSelectPeriodTypeEnum.MORNING}
							error={errors?.morning?.message}
						/>
						<RequestScheduleSelectPeriod
							periodLabel={afternoon}
							type={RequestScheduleSelectPeriodTypeEnum.AFTERNOON}
							error={errors?.afternoon?.message}
						/>
						<RequestScheduleSelectPeriod
							periodLabel={night}
							type={RequestScheduleSelectPeriodTypeEnum.NIGHT}
							error={errors?.night?.message}
							isLast
						/>
					</Stack>
				</Stack>
			) : null}
		</Stack>
	);
};
